"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketNotificationConfigurationInput_1 = require("./PutBucketNotificationConfigurationInput");
var PutBucketNotificationConfigurationOutput_1 = require("./PutBucketNotificationConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketNotificationConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketNotificationConfiguration",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?notification"
    },
    input: {
        shape: PutBucketNotificationConfigurationInput_1.PutBucketNotificationConfigurationInput
    },
    output: {
        shape: PutBucketNotificationConfigurationOutput_1.PutBucketNotificationConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketNotificationConfiguration.js.map